//export const webaddress = "http://127.0.0.1:5002";
//export const webaddress = "http://192.168.1.155:5002";
export const webaddress = "https://api.bulletboard.se";
